export const EXCHANGE_REASON_OTHER = "otros";
export const EXCHANGE_REASON_PRICE_MATCH = "ajuste_precio_dia_venta";

export const EXCHANGE_REASONS: { value: string; label: string }[] = [
  { value: "talle_incorrecto", label: "Talle incorrecto" },
  { value: "producto_defectuoso", label: "Producto defectuoso" },
  {
    value: EXCHANGE_REASON_PRICE_MATCH,
    label: "Ajuste por promo/precio del día de venta",
  },
  { value: EXCHANGE_REASON_OTHER, label: "Otros" },
];
